import { render, staticRenderFns } from "./AddRFC.vue?vue&type=template&id=5dc7282a&scoped=true&"
import script from "./AddRFC.vue?vue&type=script&lang=js&"
export * from "./AddRFC.vue?vue&type=script&lang=js&"
import style0 from "./AddRFC.vue?vue&type=style&index=0&id=5dc7282a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7282a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc7282a')) {
      api.createRecord('5dc7282a', component.options)
    } else {
      api.reload('5dc7282a', component.options)
    }
    module.hot.accept("./AddRFC.vue?vue&type=template&id=5dc7282a&scoped=true&", function () {
      api.rerender('5dc7282a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/AddRFC.vue"
export default component.exports